export const SIGNUP_ENABLED = "signup_enabled";
export const SHOW_SPLASH = "show_splash";
